import {
    ActivityFilterKey,
    useFindAssetIdForWorkspace,
} from '@gripp/shared-logic';
import {
    ActivityList,
    LoadingIndicator,
    SlideAction,
    SlideLayout,
    useSlideLayout,
    ViewMode,
} from '@gripp/shared-ui';
import { useWindowDimensions } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityFilters } from '../../activity/components/activityFilters';
import { AssetRouteProvider } from '../../assets/assetRouteContext';
import { AssetCard } from '../../assets/components/assetCard';
import { AssetFilters } from '../../assets/components/assetFilters';

export const WorkspaceDetailExpanded = () => {
  const { workspaceId = '' } = useParams();
  const navigate = useNavigate();
  const { assetId, isLoading } = useFindAssetIdForWorkspace(workspaceId);

  const routeContext = {
    basePath: `/workspaces/${workspaceId}`,
    listPath: '/workspaces',
    isWorkspaceMode: true,
  };

  const leftColumn = {
    title: 'admin.menu.workspaces',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <AssetRouteProvider value={routeContext}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ) : null,
    headerComponent:
      !isLoading && assetId ? (
        <AssetRouteProvider value={routeContext}>
          <AssetFilters assetId={assetId} />
        </AssetRouteProvider>
      ) : null,
    showBackButton: false,
    disableScroll: false,
  };

  const rightColumn = {
    title: 'activity.header.title',
    mainComponent: isLoading ? (
      <LoadingIndicator />
    ) : assetId ? (
      <RightColumn assetId={assetId} workspaceId={workspaceId} />
    ) : null,
    headerComponent:
      !isLoading && assetId ? <ActivityFilters assetId={assetId} /> : null,
    showBackButton: true,
    disableScroll: true,
    onBackButtonPress: () => {
      // navigate('..') is route-relative back — always safe regardless of
      // browser history depth. The history.state.idx guard was only needed
      // with navigate(-1) and is no longer required.
      navigate('..');
    },
    backButtonTransition: SlideAction.PREV,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const RightColumn = ({
  assetId,
  workspaceId,
}: {
  assetId: string;
  workspaceId: string;
}) => {
  const { onSlideChange } = useSlideLayout();
  const windowDimensions = useWindowDimensions();
  const windowHeight = windowDimensions?.height ?? 0;
  const maxHeight = windowHeight - 105;
  const navigate = useNavigate();

  const onIssueSelected = async (issueId: string) => {
    await onSlideChange(SlideAction.NEXT);
    navigate(`/workspaces/${workspaceId}/activity/${issueId}`);
  };

  return (
    <ActivityList
      filterKey={ActivityFilterKey.AssetActivity}
      listMaxHeight={maxHeight}
      onIssueSelected={onIssueSelected}
      assetId={assetId}
      showAssetName={false}
      pageSize={50}
    />
  );
};
